import { ViewModel,View, ObservableArray } from "binder"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import  { PersonnelAccessManipulationView } from "./personnelAccessManipulation-view"
import moment from "moment";
import { carBrand } from "src/Warehouse/carBrandManipulation/carBrandManipulation-viewModel";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";

export class PersonnelAccessManipulationViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'دسترسی های پرسنل';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.personnel = ObservableArray.create<SinglePersonnel>();
        this.refresh();
    }
    GetDefaultView(): View <ViewModel> {
        return new PersonnelAccessManipulationView();
    }
    public getTypeId(): string {
        return "VM-216F137C-6C9F-495D-957E-15D1E6AAC581"
    }

    public set personnel(v: ObservableArray<SinglePersonnel>) { this._personnel = v; } public get personnel(): ObservableArray<SinglePersonnel> { return this._personnel;} private _personnel: ObservableArray<SinglePersonnel>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
    async refresh(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/PersonnelAccessServices/GetAllPersonnelAccesses',{});
            this.personnel.update(...result.Accesses.map(x=>{
                let r = new SinglePersonnel(this);
                r.personnelId = x.PersonnelId;
                r.personnelName = x.PersonnelFullName;
                r.personnelCode = x.PersonnelCode;
                r.canReturnPurchaseFactor = x.CanReturnPurchaseFactor;
                r.canSeeWarehouseNameInHuntWindow = x.CanSeeWarehouseNameInHuntWindow;
                r.allowChangingPriceWhenDistrictIsOpen = x.AllowChangingPriceWhenDistrictIsOpen;
                r.canMultipleOpenDistrict = x.CanMultipleOpenDistrict;
                r.allowCancelSentInvoice = x.AllowCancelSentInvoice;
                r.saleReportFromDate = moment.utc(x.SaleReportFromDate);
                r.isChanged = false;
                return r;
            }))
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    async showCarBrand(personnel: SinglePersonnel) {
        let personnelCarBrandAccess = new PersonnelCarBrandAccess(this);
        personnelCarBrandAccess.loadById(personnel.personnelId);
        let result = await this.showPopup(personnelCarBrandAccess);
        if(result = true){
            this.refresh();
        }
        try {
            this.isLoading = true;
            
            if(result.IsSuccessful){
                
            }
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
        
    async save(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/PersonnelAccessServices/UpdatePersonnelAccess',{
                ChangedAccesses : this.personnel.filter(x=>x.isChanged==true).map(x=>{
                    return {
                        PersonnelId : x.personnelId,
                        CanReturnPurchaseFactor : x.canReturnPurchaseFactor,
                        CanSeeWarehouseNameInHuntWindow : x.canSeeWarehouseNameInHuntWindow,
                        AllowChangingPriceWhenDistrictIsOpen : x.allowChangingPriceWhenDistrictIsOpen,
                        AllowCancelSentInvoice : x.allowCancelSentInvoice,
                        CanMultipleOpenDistrict : x.canMultipleOpenDistrict,
                        SaleReportFromDate : x.saleReportFromDate
                    }
                })
            });
            if(result.IsSuccessful){
                this.refresh();
                await this.messageBoxConfirmSuccess('عملیات با موفقیت انجام شد','عملیات موفق');
            }else{
                await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
            }
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
        }
    }
}


export class SinglePersonnel extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:PersonnelAccessManipulationViewModel) {
        super(parent);
        this.canSeeWarehouseNameInHuntWindow = false;
        this.canReturnPurchaseFactor = false;    
        this.allowCancelSentInvoice = false;    
        this.isChanged = false;
        this._typedParent = parent;
    }
    
    public set personnelId(v: string) { this._personnelId = v; } public get personnelId(): string { return this._personnelId;} private _personnelId: string;
    public set personnelName(v: string) { this._personnelName = v; } public get personnelName(): string { return this._personnelName;} private _personnelName: string;
    public set personnelCode(v: string) { this._personnelCode = v; } public get personnelCode(): string { return this._personnelCode;} private _personnelCode: string;
    public set allowChangingPriceWhenDistrictIsOpen(v: boolean) { 
        if(this._allowChangingPriceWhenDistrictIsOpen != v){
            this.isChanged = true;
        }
        this._allowChangingPriceWhenDistrictIsOpen = v; 
    
    } public get allowChangingPriceWhenDistrictIsOpen(): boolean { return this._allowChangingPriceWhenDistrictIsOpen;} private _allowChangingPriceWhenDistrictIsOpen: boolean;
    
    public set canReturnPurchaseFactor(v: boolean) { 
        if(this._canReturnPurchaseFactor != v){
            this.isChanged = true;
        }
        this._canReturnPurchaseFactor = v; 
        
    } public get canReturnPurchaseFactor(): boolean { return this._canReturnPurchaseFactor;} private _canReturnPurchaseFactor: boolean;
    public set canSeeWarehouseNameInHuntWindow(v: boolean) { 
        if(this._canSeeWarehouseNameInHuntWindow != v){
            this.isChanged = true;
        }
        this._canSeeWarehouseNameInHuntWindow = v; 
    } public get canSeeWarehouseNameInHuntWindow(): boolean { return this._canSeeWarehouseNameInHuntWindow;} private _canSeeWarehouseNameInHuntWindow: boolean;
    public set allowCancelSentInvoice(v: boolean) { 
        if(this._allowCancelSentInvoice != v){
            this.isChanged = true;
        }
        this._allowCancelSentInvoice = v; 
    } public get allowCancelSentInvoice(): boolean { return this._allowCancelSentInvoice;} private _allowCancelSentInvoice: boolean;
    public set canMultipleOpenDistrict(v: boolean) { 
        if(this._canMultipleOpenDistrict != v){
            this.isChanged = true;
        }
        this._canMultipleOpenDistrict = v; 
    } public get canMultipleOpenDistrict(): boolean { return this._canMultipleOpenDistrict;} private _canMultipleOpenDistrict: boolean;
    public set saleReportFromDate(v: moment.Moment) { 
        if (this._saleReportFromDate != v) {
            this.isChanged = true;
        }
        this._saleReportFromDate = v; } public get saleReportFromDate(): moment.Moment { return this._saleReportFromDate;} private _saleReportFromDate: moment.Moment;
    public set isChanged(v: boolean) { this._isChanged = v; } public get isChanged(): boolean { return this._isChanged;} private _isChanged: boolean;
    
    private _typedParent : PersonnelAccessManipulationViewModel;

    async showCarBrand() {
        try {
            this._typedParent.showCarBrand(this);
        } catch (ex) {
            console.log(ex);
        } finally {
        }
    }
}
export class PersonnelCarBrandAccess extends ViewModel implements IPopup{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        this.carBrands = ObservableArray.create<CarBrand>();
    }
    
    closePopup(result: boolean = false) {
       
    }
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;

    public set personnelId(v: string) { this._personnelId = v; } public get personnelId(): string { return this._personnelId;} private _personnelId: string;
    public set personnelName(v: string) { this._personnelName = v; } public get personnelName(): string { return this._personnelName;} private _personnelName: string;
    public set personnelCode(v: string) { this._personnelCode = v; } public get personnelCode(): string { return this._personnelCode;} private _personnelCode: string;
    public set carBrands(v: ObservableArray<CarBrand>) { this._carBrands = v; } public get carBrands(): ObservableArray<CarBrand> { return this._carBrands;} private _carBrands: ObservableArray<CarBrand>;
    

    async loadById(id: string) {
        this.isLoading = true;
        let result = await ServerConnection.callServer('/Complex/PersonnelAccessServices/GetPersonnelCarBrandAccess',{
            PersonnelId : id
        });
        this.personnelId = result.PersonnelId;
        this.personnelName = result.PersonnelFullName;
        this.personnelCode = result.PersonnelCode;
        this.carBrands.update(...result.CarBrands.map(q => {
            let r = new CarBrand(this);
            r.id = q.CarBrandId;
            r.name = q.Name;
            r.code = q.Code;
            r.selected = q.Selected;
            return r;
        }));
        this.isLoading = false;
    }
    
    back() {
        this.closePopup();
    }

    async confirm() {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('Complex/PersonnelAccessServices/SetPersonnelCarBrandAccess', {
                PersonnelId: this.personnelId,
                CarBrands: this.carBrands.filter(q => q.selected).map(q => q.id)
            });
            if(result.IsSuccessful){
                await this.messageBoxConfirmSuccess("اطلاعات با موفقیت ذخیره شد.", "ثبت دسترسی برندهای خودرو");
                this.closePopup(true);
            }
            else{
                await this.messageBoxConfirmWarning("امکان ثبت وجود ندارد.",'خطا');
            }
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

}

export class CarBrand extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code;} private _code: string;
    public set selected(v: boolean) { this._selected = v; } public get selected(): boolean { return this._selected;} private _selected: boolean;
    
    async toggleSelect() {
        this.selected = !this.selected;
    }
}